import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';

const EditBeforePublicationfordean = () => {
  const { id } = useParams();
  const history = useHistory();
  const [publication, setPublication] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublication = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/beforepublications/${id}`);
        setPublication(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching publication:', err);
        setLoading(false);
      }
    };

    fetchPublication();
  }, [id]);

  const handleStatusUpdate = async (newStatus) => {
    try {
      const updatedPublication = { ...publication, status: newStatus };
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/beforepublications/approve-or-reject/${id}`, updatedPublication);
      alert(newStatus === '3' ? 'Approved successfully.' : 'Rejected successfully.');
      history.push('/beforepubfordean');
    } catch (err) {
      console.error('Error updating publication:', err);
      alert('Approval action failed.');
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!publication) return <p>No publication found.</p>;

  if (publication.status !== '1' && publication.status !== '2') {
  return <p className="text-danger text-center mt-4">You can only review pending or rejected publications.</p>;
}


  return (
    <div className="container mt-4">
      <h3 className="mb-4 text-primary text-center">Review Before Publication</h3>
      <div className="card p-4 shadow">
        <div className="mb-3">
          <label className="form-label">Paper Title</label>
        {['2', '3'].includes(publication.status) && (
      <span className={`badge ms-3 ${
        publication.status === '2' ? 'bg-danger' : 'bg-success'
      }`}>
        {publication.status === '2' ? 'Rejected' : 'Approved'}
      </span>
    )}
          <input
            type="text"
            className="form-control"
            value={publication.paperTitle}
            disabled
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Journal Name</label>
          <input
            type="text"
            className="form-control"
            value={publication.journalName}
            disabled
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Citation References</label>
          {publication.citations.length > 0 ? (
            publication.citations.map((cite, index) => (
              <div key={index} className="form-control mb-2" style={{ backgroundColor: "#f8f9fa" }}>
                {cite}
              </div>
            ))
          ) : (
            <p className="text-muted">No citations provided.</p>
          )}
        </div>

        <div className="d-flex justify-content-end gap-3">
          <button
            className="btn btn-success"
            onClick={() => handleStatusUpdate('3')}
          >
            Approve
          </button>
          <button
            className="btn btn-danger"
            onClick={() => handleStatusUpdate('2')}
          >
            Reject
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => history.push('/beforepublications/pending')}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditBeforePublicationfordean;
